import axios from 'axios';

export default {
  fetchCurrentPage ({ commit, state }, data) {
    let host = window.location.href.split('/')[2]

    return axios.post(`${state.api}/api/page/block`, {
      page: data.page,
      host: host
    }).then(res => {
      commit('currentPage', res.data)
    }).finally(() => {
      let event = new CustomEvent('cutomMount');
      window.dispatchEvent(event);
    })
  },
  fetchTemplate ({ commit, state }) {
    return axios.post(`${state.api}/api/page/block`, {
      page: 'template'
    }).then(res => {
      commit('currentTemplate', res.data)
    }).finally(() => {
        let event = new CustomEvent('cutomMount');
        window.dispatchEvent(event);
    })
  },
  fetchCity ({ commit, state }) {
    return axios.get(`${state.api}/api/city`).then(res => {
      let host = window.location.href.split('/')[2]
      commit('cityList', {host: host, list: res.data})
    })
  },
  Auth ({ commit }, data) {
      commit('Auth', data)
  }
}


// WEBPACK FOOTER //
// ./src/store/actions.js